export default {
      id: "icon--star-full-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--star-full-usage",
      toString: function () {
        return this.url;
      }
    }